var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 24V0h30v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M15 24V0h15v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.37 5.07v-.03a.6.6 0 0 0-.5-.46V3H5.02v1.58H5a.6.6 0 0 0-.47.49H2.95v1.86h1.57v.03a.6.6 0 0 0 .5.46V9h1.86V7.42h.02a.6.6 0 0 0 .47-.5h1.57V5.08z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cb2e40",
    d: "M7.13 9.25H4.76V7.6a1 1 0 0 1-.42-.43H2.7V4.82h1.64a1 1 0 0 1 .42-.43V2.75h2.37v1.64q.29.14.42.43H9.2v2.36H7.55a1 1 0 0 1-.42.43zm-.5-.5V7.2l.2-.04a.4.4 0 0 0 .29-.28l.03-.21H8.7V5.32H7.14l-.02-.22a.4.4 0 0 0-.28-.28l-.21-.03V3.25H5.26v1.54l-.2.03a.4.4 0 0 0-.29.28l-.03.22H3.2v1.36h1.52l.05.2q.07.25.28.3l.21.03v1.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalta);
export default __webpack_public_path__ + "static/media/malta.1f5b231a0e476667cccd1ee253f07f0e.svg";
export { ForwardRef as ReactComponent };